/**
 * Shared constants for the application
 */

/** Number of items to fetch per page for video listings */
export const VIDEOS_PAGE_SIZE = 20

/** Number of items to fetch per page for file listings */
export const FILES_PAGE_SIZE = 20

/** Number of skeleton items to show during loading */
export const LOADING_SKELETON_COUNT = 4

/**
 * Membership Plan IDs
 */

/** Swaggy's Vault premium plan — users must have this to access the app */
export const VAULT_PLAN_ID = 11

/** Free Plan — default for new users without a purchase */
export const FREE_PLAN_ID = 9

/**
 * Listing category IDs
 */
export const LISTING_CATEGORY_IDS = {
  /** Video listings category */
  VIDEO: 1,
  /** Playlist listings category */
  PLAYLIST: 2,
  /** File downloads category */
  FILE: 3,
} as const

/**
 * Custom field IDs for video listings (category_id = 1)
 */
export const VIDEO_FIELD_IDS = {
  videotitle: 1,
  videodescription: 2,
  videocategory: 3,
  video: 5,
  thumbnailurl: 6,
} as const

/**
 * Custom field IDs for playlist listings (category_id = 2)
 */
export const PLAYLIST_FIELD_IDS = {
  /** Playlist title - text field (field ID 7) - note: field name has double 't' in database */
  playlisttittle: 7,
  /** Playlist listings - JSON array of video listing IDs with order (field ID 8) */
  playlistlistings: 8,
  /** Playlist category - same options as video category (field ID 3) */
  playlistcategory: 3,
} as const

/**
 * Custom field IDs for file listings (category_id = 3)
 */
export const FILE_FIELD_IDS = {
  /** File name - text field (field ID 9) */
  filename: 9,
  /** Digital file - file upload field (field ID 10) */
  digitalfile: 10,
} as const

/**
 * Video category options (used for both videos and playlists)
 * Note: This is now used as a fallback when the API call to fetch
 * dynamic categories fails. Categories are primarily fetched from
 * the backend via GET /api/listings/category-custom-fields?category_id=1
 */
export const VIDEO_CATEGORY_OPTIONS = [
  "Old Swag Academy",
  "The Blueprint",
  "Shift Szn",
  "Live Trading Lab",
  "Deep Pockets",
  "YouTube Archived",
] as const

/**
 * Defines the display order of categories in the sidebar and category tabs.
 * Categories from Meilisearch will be sorted according to this order.
 * Any categories not in this list will appear at the end, sorted alphabetically.
 */
export const CATEGORY_DISPLAY_ORDER = [
  "Deep Pockets",
  "The Goat Academy",
  "The Swag Academy",
  "Personal Finance",
  "YouTube Archived",
  "Unseen Footage",
  "Shift SZN",
  "Trades Only",
  "Mentorship",
] as const

/**
 * Maps backend category names to frontend display names.
 * Used when a category should display differently than how it's stored in the backend.
 */
export const CATEGORY_DISPLAY_NAMES: Record<string, string> = {
  "Trades Only": "TradesOnly.com",
}

/**
 * Get the display name for a category.
 * Returns the mapped display name if one exists, otherwise returns the original name.
 * @param categoryName - The category name from the backend
 * @returns The display name to show in the UI
 */
export function getCategoryDisplayName(categoryName: string): string {
  return CATEGORY_DISPLAY_NAMES[categoryName] ?? categoryName
}

/**
 * Defines the display order of playlists within their category sublists.
 * Playlists matching these names (case-insensitive) will appear first in their defined order.
 * Any playlists not in this list will appear after, sorted alphabetically.
 */
export const PLAYLIST_DISPLAY_ORDER = [
  "Swaggy",
  "Series 1 (Beginners)",
] as const

/**
 * Global description displayed above all video descriptions
 * This includes promotional links and resources
 */
export const GLOBAL_VIDEO_DESCRIPTION = {
  title: "BIRTHDAY LAUNCH ONLY",
  items: [
    {
      label: "PROP FIRM",
      url: "https://tradeprime.com/",
      linkText: "tradeprime.com",
      description: "Rapid Funding. Immediate Payouts. Zero Delays. A REVOLUTIONARY firm where you keep your profits even if you breach your account.",
    },
    {
      label: "MENTORSHIP",
      url: "https://form.jotform.com/260007092898058",
      linkText: "form.jotform.com/260007092898058",
      description: "Our mentorship is sold out! But sign up for our waitlist to be informed the moment we open back up. Once we do, we only onboard 20 slots, so put your name down so you can at least be alerted when there's an opportunity!",
    },
  ],
} as const
